import {Navigate, useOutlet} from 'react-router-dom'
import {AppLayout} from "./appLayout";

const ProtectedLayout = (props) => {
    let user = null;
    try {
        user = JSON.parse(localStorage.getItem('insurlyUser'));
    }
    catch (err) {
        localStorage.removeItem('insurlyUser');
    }

    const outlet = useOutlet();

    let token = false;
    if (user && user.token && user.email) {
        token = true;
    }
    let layout;
    if (token) {
        if (user.role) {
            switch (user.role) {
                case 'root':
                    layout = <div>
                        <AppLayout
                            page={props.page}
                            title={props.title}
                        />
                        {outlet}
                    </div>
                    break;
                case 'admin':
                    layout = <div>
                        <AppLayout
                            page={props.page}
                            title={props.title}
                        />
                        {outlet}
                    </div>
                    break;
                default:
                    localStorage.removeItem('insurlyUser');
                    layout = <Navigate to="/"/>
            }
        } else {
            localStorage.removeItem('insurlyUser');
            layout = <Navigate to="/"/>
        }
    } else {
        localStorage.removeItem('insurlyUser');
        layout = <Navigate to="/"/>
    }

    return (
        <div>
            {layout}
        </div>
    )
};

export default ProtectedLayout